import React, { useState } from "react";

const ColumnSelector = ({ availableColumns, selectedColumns, onChange }) => {
  const [filter, setFilter] = useState("");

  const handleToggle = (col) => {
    if (selectedColumns.includes(col)) {
      onChange(selectedColumns.filter(c => c !== col));
    } else {
      onChange([...selectedColumns, col]);
    }
  };

  const handleSelectAll = () => {
    onChange(availableColumns);
  };

  const handleUnselectAll = () => {
    onChange([]);
  };

  // Filter columns based on user input, but keep selection logic unchanged
  const filteredColumns = availableColumns.filter(col =>
    col.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <>
      <h5 className="bg-secondary text-white px-2 py-2 border rounded">Select Columns</h5>
      {availableColumns.length <= 0 ? (
        'Please select tables..'
      ) : (
        <>
          <div className="mb-2">
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              placeholder="Search column..."
              value={filter}
              onChange={e => setFilter(e.target.value)}
            />
            <button className="btn btn-sm btn-outline-primary me-2" onClick={handleSelectAll}>Select All</button>
            <button className="btn btn-sm btn-outline-danger" onClick={handleUnselectAll}>Unselect All</button>
          </div>

          <div style={{ maxHeight: "200px" }} className="mb-3 overflow-y-auto border border-secondary rounded px-4 p-2">
            {filteredColumns.map((col, index) => (
              <div key={index} className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`col-${index}`}
                  checked={selectedColumns.includes(col)}
                  onChange={() => handleToggle(col)}
                />
                <label className="form-check-label" htmlFor={`col-${index}`}>{col}</label>
              </div>
            ))}
            {filteredColumns.length === 0 && (
              <div className="text-muted px-2 py-1">No columns found.</div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ColumnSelector;
